import { BrowserRouter, Route, Routes } from 'react-router-dom'

import {
  Admin,
  // AdminOrderA,
  // AdminOrderR,
  // AdminOrderRWithBankAccount,
  AdminPartnerReport,
  AdminCodingAssement,
  AdminSafetyAnswer,
  AdminSafetyNotify,
  AdminSafetyReport,
  AdminSchedule,
  AdminSafetyCheck,
  AdminSolarApproval,
  AdminSolarApproval2,
  AdminSolarData
} from './components/Admin'

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/order/*" element={<AdminOrderA />} /> */}
        {/* <Route path="/orderA/*" element={<AdminOrderA />} /> */}
        {/* <Route path="/orderR/:id/:product" element={<AdminOrderR />} />
        <Route path="/orderR/:id/:product/*" element={<AdminOrderR />} /> */}
        <Route path="/safetyReport/:id" element={<AdminSafetyReport />} />
        <Route path="/safetyAnswer/:id" element={<AdminSafetyAnswer />} />
        <Route path="/safetyAnswer/:id/*" element={<AdminSafetyAnswer />} />
        <Route path="/safetyNotify/:id" element={<AdminSafetyNotify />} />
        <Route path="/safetyCheck/:id" element={<AdminSafetyCheck />} />
        <Route path="/safetyCheck/:id/*" element={<AdminSafetyCheck />} />
        {/* <Route
          path="/orderRWithBankAccount/:id/:product"
          element={<AdminOrderRWithBankAccount />}
        />
        <Route
          path="/orderRWithBankAccount/:id/:product/*"
          element={<AdminOrderRWithBankAccount />}
        />
        <Route path="/bankAccount/*" element={<AdminOrderRWithBankAccount />} /> */}
        <Route path="/partnerReport/:id" element={<AdminPartnerReport />} />
        <Route path="/partnerReport/:id/*" element={<AdminPartnerReport />} />
        <Route path="/codingAssesment/:id" element={<AdminCodingAssement />} />
        <Route
          path="/codingAssesment/:id/*"
          element={<AdminCodingAssement />}
        />
        <Route path="/schedule/:id/:notification" element={<AdminSchedule />} />
        <Route
          path="/schedule/:id/:notification/:maxDays"
          element={<AdminSchedule />}
        />
        {/* <Route
          path="/schedule/:id/:notification/*"
          element={<AdminSchedule />}
        /> */}
        <Route
          path="/solarApproval/:partner/:id"
          element={<AdminSolarApproval />}
        />
        <Route
          path="/solarApproval2/:partner/:id/:hash"
          element={<AdminSolarApproval2 />}
        />
        <Route
          path="/solarApproval/:partner/:id/*"
          element={<AdminSolarApproval />}
        />
        <Route path="/solarData/:partner/:hash" element={<AdminSolarData />} />
        <Route path="/*" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
